const comments = [
  {
    name: '老站长',
    time: '3天前',
    text: '这个导航站真的帮了大忙！51cg的域名经常变，以前总是找不到入口，现在收藏这个站就行了，更新很及时，给力！',
    avatar: 'L',
  },
  {
    name: '资讯爱好者',
    time: '5天前',
    text: '一直在用51cg看内容，有了这个网址导航方便多了，再也不用担心找不到官网了。介绍也很详细，新手也能快速上手。',
    avatar: 'Z',
  },
  {
    name: '安全第一',
    time: '1周前',
    text: '之前差点上了仿冒站的当，还好看到这里的安全提醒。认准导航站收录的官方入口确实很重要，感谢整理！',
    avatar: 'A',
  },
  {
    name: '新用户小陈',
    time: '1周前',
    text: '刚接触51cg，通过这个导航站了解了平台的基本情况和功能，帮助很大。希望继续更新更多使用技巧。',
    avatar: 'X',
  },
];

export default function CommentSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">读者评论</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">来自访问者的真实反馈，听听大家怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {comments.map((c, i) => (
            <div
              key={i}
              className="p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-sm font-bold text-secondary-700 flex-shrink-0">
                  {c.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-bold text-foreground-900">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}